import * as React from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Paper from '@mui/material/Paper'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from "react-i18next"
import { Tooltip } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import TablePagination from "@mui/material/TablePagination";
import { t } from 'i18next'
import dayjs from 'dayjs'
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect } from 'react'
import AssignForklifter from './sales_purchase_orders/AssignForklifter'
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import { visuallyHidden } from '@mui/utils';
import { getComparator, stableSort } from '../helpers/DailyBoardTableHelpers'
import { useStateContext } from '../context/ContextProvider'
import MoveSite from './sales_purchase_orders/MoveSite'

function Row(props) {
    const { features } = useStateContext();
    const { row, user, setIsLoading } = props;
    const [open, setOpen] = React.useState(false)

    return (
        <React.Fragment >
            <TableRow sx={{ '& > *': { borderBottom: 'unset !important' } }}>
                <TableCell sx={{ padding: '8px 16px', position: 'relative', fontWeight: '500' }}>
                    {
                        row.type == 'STREET COLLECTION' ?
                            <Tooltip disableInteractive title={t('street_collection')}>
                                <div style={{ position: 'absolute', top: 0, left: 0, border: '7.5px solid', borderColor: `rgb(211, 211, 30) transparent transparent rgb(211, 211, 30)`, cursor: 'pointer' }}></div>
                            </Tooltip>
                            :
                            null
                    }
                    {
                        row.type == '3PL' ?
                            <Tooltip disableInteractive title={t('3PL')}>
                                <div style={{ position: 'absolute', top: 0, left: 0, border: '7.5px solid', borderColor: `rgb(76, 175, 80) transparent transparent rgb(76, 175, 80)`, cursor: 'pointer' }}></div>
                            </Tooltip>
                            :
                            null
                    }
                    {row.po_number}
                </TableCell>
                <TableCell sx={{ padding: '8px 16px', fontStyle: 'italic' }}>{row.vendor_name}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>{<ShowDate date={row.requested_collection_date} />}</TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    {
                        <Status status={row.po_status_id} forklifter={row.forklift_driver_name} status_name={row.po_status_name} driver={row.driver_name} />
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 5px' }}>
                    {
                        <TodaysPurchaseOrderAction id={row.id} siteId={row?.site_id} status={row.po_status_id} statusSlug={row.po_status} statusName={row.po_status_name} prevStatusSlug={row.prev_status?.key} prevStatusName={row.prev_status?.name} forklifter={{id: row.forklift_driver_id, name: row.forklift_driver_name}} type={row.type} deletedAt={row.deleted_at} user={user} setIsLoading={setIsLoading}/>
                    }
                </TableCell>
                <TableCell sx={{ padding: '8px 16px' }}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell style={{ padding: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '20%' }}>{t('item_no')}</TableCell>
                                        <TableCell sx={{ width: (features?.DRIVER_QUANTITIES == 1 && row.type == 'COLLECTION') ? '30%' : '45%' }}>{t('description')}</TableCell>
                                        <TableCell sx={{ width: '20%' }}>{t('quantity_ordered')}</TableCell>
                                        <TableCell sx={{ width: '15%' }}>{localStorage.getItem('client_id') === 'arbor-trace' ? t('quantity_shipped') : t('vendor_count')}</TableCell>
                                        {
                                            (features?.DRIVER_QUANTITIES == 1 && row.type == 'COLLECTION') && (
                                                <TableCell sx={{ width: '15%', fontSize: "inherit" }}>{t('driver_quantity')}</TableCell>
                                            )
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.purchase_order_items.map((historyRow) => (
                                        <TableRow key={historyRow.id}>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.item_no}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.description}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{historyRow.qty_ordered}</TableCell>
                                            <TableCell sx={{ padding: '8px 16px' }}>{localStorage.getItem('client_id') === 'arbor-trace' ? historyRow.qty_to_receive : historyRow.vendor_count}</TableCell>
                                            {
                                                (features?.DRIVER_QUANTITIES == 1 && row.type == 'COLLECTION') && (
                                                    <TableCell sx={{ padding: '8px 16px' }}>{historyRow?.driver_qty}</TableCell>
                                                )
                                            }
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </React.Fragment>
    );
}

const SortableTableHeaderRow = (props) => {
    const { order, orderBy, onRequestSort } = props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }

    return (
        <TableHead>
            <TableRow>
                {/* Purchase Order No. cell */}
                <TableCell
                    sortDirection={orderBy === 'po_number' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'po_number'}
                        direction={orderBy === 'po_number' ? order : 'asc'}
                        onClick={createSortHandler('po_number')}>
                        {t('purchase_order_no')}
                        {orderBy === 'po_number' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Vendor Name cell */}
                <TableCell
                    sortDirection={orderBy === 'vendor_name' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'vendor_name'}
                        direction={orderBy === 'vendor_name' ? order : 'asc'}
                        onClick={createSortHandler('vendor_name')}>
                        {t('vendor')}
                        {orderBy === 'vendor_name' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Requested COllection Date cell */}
                <TableCell
                    sortDirection={orderBy === 'requested_collection_date' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'requested_collection_date'}
                        direction={orderBy === 'requested_collection_date' ? order : 'asc'}
                        onClick={createSortHandler('requested_collection_date')}>
                        {t('requested_collection_date')}
                        {orderBy === 'requested_collection_date' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                {/* Status cell */}
                <TableCell
                    sortDirection={orderBy === 'po_status' ? order : false}>
                    <TableSortLabel sx={{ color: '#88909C !important', fontWeight: '400' }}
                        active={orderBy === 'po_status'}
                        direction={orderBy === 'po_status' ? order : 'asc'}
                        onClick={createSortHandler('po_status')}>
                        {t('status')}
                        {orderBy === 'po_status' ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: '#88909C !important', fontWeight: '400' }}>{t('actions')}</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>
    )
}

export default function CollapsibleTable({ items, total, user, page = 1, rowsPerPage = 10, opc = undefined, orppc = undefined, osc = undefined }) {

    const { t } = useTranslation()

    const pg = Number(page - 1)
    const rpg = Number(rowsPerPage)

    const [orderBy, setOrderBy] = useState('created_at')
    const [order, setOrder] = useState('desc')

    function handleChangePage(event, newpage) {
        if(opc) {
            opc(Number(newpage + 1));
        }
    }

    function handleChangeRowsPerPage(event) {
        if(orppc) {
            opc(1);
            orppc(parseInt(event.target.value, 10));
        }
    }

    const handleRequestSort = (event, property) => {
        if (order === 'desc' && orderBy === property) {
            setOrderBy('created_at')
            if(osc) {
                osc('created_at,desc')
            }
        } else {
            const isAsc = orderBy === property && order === 'asc'
            setOrder(isAsc ? 'desc' : 'asc')
            setOrderBy(property)
            if(osc) {
                osc(`${property},${isAsc ? 'desc' : 'asc'}`)
            }
        }
    }

    return (
        <>
            <div style={{ width: '100%', mb: 2, border: 'none' }}>
                <TableContainer>
                    <Table aria-label="collapsible table" stickyHeader>
                        <colgroup>
                            <col width="15%" />
                            <col width="15%" />
                            <col width="25%" />
                            <col width="25%" />
                            <col width="10%" />
                            <col />
                        </colgroup>
                        <SortableTableHeaderRow
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                        />
                        <TableBody>
                            {items.length <= 0 ? <TableRow><TableCell colSpan={6} sx={{ textAlign: 'center' }}>{t('no_data')}</TableCell></TableRow> : null}
                            {items?.map((row) => (
                                <Row key={row.id} row={row} user={user} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    className='table-pagination'
                    labelRowsPerPage={t('rowsPerPage')}
                    rowsPerPageOptions={[10, 15]}
                    component="div"
                    count={total}
                    rowsPerPage={rpg}
                    page={pg}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </>
    );
}

const Status = ({ status, status_name, forklifter, driver }) => {

    return (
        <>
            {
                status == 7 ?
                    forklifter ?
                        <Tooltip disableInteractive title={forklifter} placement='bottom'>
                            <div className='w-full bg-[#FFF0B6] rounded-md p-1 text-center text-[#8A5001] font-[500]'>{status_name}</div>
                        </Tooltip>
                        :
                        <div className='w-full bg-[#FFF0B6] rounded-md p-1 text-center text-[#8A5001] font-[500]'>{status_name}</div>
                    :
                    status == 4 ?
                        driver ?
                            <Tooltip disableInteractive title={driver} placement='bottom'>
                                <div className='w-full bg-[#FFE4B9] rounded-md p-1 text-center text-[#804E00] font-[500]'>{status_name}</div>
                            </Tooltip>
                            :
                            <div className='w-full bg-[#FFE4B9] rounded-md p-1 text-center text-[#804E00] font-[500]'>{status_name}</div>
                        :
                        status == 1 ?
                            <div className='w-full bg-[#D2ECFE] rounded-md p-1 text-[#0073C1] text-center font-[500]'>{status_name}</div>
                            :
                            status == 2 ?
                                <div className='w-full bg-[#FFD48F] rounded-md p-1 text-[#9D6000] text-center font-[500]'>{status_name}</div>
                                :
                                status == 3 ?
                                    <div className='w-full bg-[#D2ECFE] rounded-md p-1 text-[#0073C1] text-center font-[500]'>{status_name}</div>
                                    :
                                    status == 8 ?
                                        <div className='w-full bg-[#FDFF8D] rounded-md p-1 text-[#BB7B00] text-center font-[500]'>{status_name}</div>
                                        :
                                        status == 9 ?
                                            <div className='w-full bg-[#FFED8D] rounded-md p-1 text-[#B16103] text-center font-[500]'>{status_name}</div>
                                            :
                                            status == 5 ?
                                                <div className='w-full bg-[#D5EDFB] rounded-md p-1 text-[#008A93] text-center font-[500]'>{status_name}</div>
                                                :
                                                status == 6 ?
                                                    <div className='w-full bg-[#BEFFD6] rounded-md p-1 text-[#017C40] text-center font-[500]'>{status_name}</div>
                                                    :
                                                    status == 11 ?
                                                        <div className='w-full bg-[#E8E8E8] rounded-md p-1 text-[#515151] text-center font-[500]'>{status_name}</div>
                                                        :
                                                        status == 10 ?
                                                            <div className='w-full bg-[#BEFFD6] rounded-md p-1 text-[#017C40] text-center font-[500]'>{status_name}</div>
                                                            :
                                                            status == 12 ?
                                                                <div className='w-full bg-[#FFD1D1] rounded-md p-1 text-[#B81100] text-center font-[500]'>{status_name}</div>
                                                                :
                                                                ''
            }
        </>
    )
}

const TodaysPurchaseOrderAction = ({ id, siteId, status, statusSlug, statusName, prevStatusSlug, prevStatusName, forklifter, type, deletedAt, user, setIsLoading }) => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()

    const [open, setOpen] = useState(false)

    const openPopup = () => {
        setOpen(!open)
    }

    const userHasPermissions = (targets = []) => {
        return user?.permissions.some((permission) => targets.includes(permission.name))
    }

    const { allSites } = useStateContext()
    const sites = allSites?.filter((site) => site.company_id == localStorage.getItem('company_id'));
    const [openMoveSite, setOpenMoveSite] = useState(false);

    const moveSiteBlockedBy = ['in_transit', 'unloading'].includes(statusSlug) ? statusName : null;
    const delicatePreviousStatus = (['in_transit', 'unloading'].includes(prevStatusSlug) && ['reopened'].includes(statusSlug)) ? prevStatusName : null;

    return (
        <>
            <div className='flex gap-1'>
                <Tooltip disableInteractive title="BOL/POD" placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <a href={process.env.REACT_APP_BACKEND_URL + `/api/purchase-orders/${id}/proof-of-delivery?CLIENT_ID=${localStorage.getItem('client_id')}&CLIENT_TIMEZONE=${encodeURIComponent(localStorage.getItem('client_timezone'))}`} target="_blank"><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-print"></i></span></a>
                    </div>
                </Tooltip>

                {
                    (
                        (
                            ['master_admin', 'office_manager'].includes(user?.role)
                            || userHasPermissions(['daily-board-update'])
                        )
                        && (
                            status === 1
                            || status === 3
                        )
                    ) ? (
                        <Tooltip disableInteractive title={t('update')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(`${id}`, { state: { prevPathname: location.pathname } })}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-pencil"></i></span></button>
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip disableInteractive title={t('open')} placement='bottom'>
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <button onClick={() => navigate(`${id}`, { state: { prevPathname: location.pathname } })}><span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><i className="fa-solid fa-eye"></i></span></button>
                            </div>
                        </Tooltip>
                    )
                }

                {(['master_admin', 'office_manager'].includes(user?.role)) && (status === 6 || status === 7) ?
                    (
                        type != 'STREET COLLECTION' ?
                            <Tooltip disableInteractive title={t('assign_forklifter')} placement='bottom'>
                                <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                    <span style={{ cursor: 'pointer' }} onClick={openPopup} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"><VerticalAlignTopIcon /></span>
                                </div>
                            </Tooltip>
                            :
                            null
                    )
                    :
                    ''
                }

                {
                    (['master_admin', 'office_manager'].includes(user?.role) && sites.length > 1 && !deletedAt) && (
                        <Tooltip
                            disableInteractive
                            title={moveSiteBlockedBy
                                ? t('cannot_move_site_while_x', { x: moveSiteBlockedBy })
                                : delicatePreviousStatus
                                    ? "Cannot move sites while the order is being processed or has been reopened for editing"
                                    : t('move_site')
                            }
                            placement='bottom'
                        >
                            <div style={{ color: 'rgba(0,0,0,.54)' }}>
                                <span
                                    style={{ cursor: (moveSiteBlockedBy || delicatePreviousStatus) ? 'not-allowed' : 'pointer', opacity: (moveSiteBlockedBy || delicatePreviousStatus) ? 0.4 : 1 }}
                                    className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200"
                                    onClick={(e) => { if(!(moveSiteBlockedBy || delicatePreviousStatus)) { setOpenMoveSite(true) } }}
                                ><i className="fa-solid fa-building-circle-arrow-right"></i></span>
                            </div>
                        </Tooltip>
                    )
                }
            </div>
            <AssignForklifter open={open} setOpen={setOpen} orderId={id} siteId={siteId} _forklifter={forklifter} type={"purchase"} setIsLoading={setIsLoading} />
            <MoveSite
                open={openMoveSite}
                setOpen={setOpenMoveSite}
                id={id}
                _siteId={siteId}
                type="purchase"
                sites={sites}
            />
        </>
    )
}

export const ShowDate = ({ date }) => {

    const date1 = new Date(dayjs(date).format("YYYY-MM-DD"))
    const date2 = new Date(dayjs().format("YYYY-MM-DD"))

    return (
        <div>
            {
                date1 < date2 ? <p style={{ color: '#F00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                    date1 == date2 ? <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                        date1 > date2 ? <p style={{ color: '#008E00', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p> :
                            <p style={{ color: 'blue', padding: '5px', lineHeight: '1', width: 'fit-content' }}>{dayjs(date).format("MMMM D, YYYY")}</p>
            }
        </div>
    )
}
